import { IonIcon, IonText, IonGrid, IonCol, IonRow, IonImg, IonNote, IonSpinner, useIonViewWillEnter, useIonRouter, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { logoGooglePlaystore, logoAppleAppstore, cloudDownloadOutline, wallet } from 'ionicons/icons';
import './Main.css';

import { LANGUAGE, GetStr } from "../language/Language";
import { Storage } from '@capacitor/storage';
import NServer from "../components/NServer";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';
import { GameInfo } from "../data/game_info";

export interface GameIDParam extends RouteComponentProps<{
    id : any
    }> 
{}


const GameInfoPage : React.FC<GameIDParam> = ({match}) => {

    const [gameInfo, setGameInfo] = useState<GameInfo>();

    //	Initializing our router
	const router = useIonRouter();

    useIonViewWillEnter(() => {
        getData();
    });

    const getData = async () => {
        
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            game: match.params.id
        }

		var server = new NServer();
        await server.getList("get_game", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // update the UI
            setGameInfo(server.data.game);
        }
	}

    // download from google playstore
    const downloadPlaystore = () => {
        
        if (gameInfo !== undefined)
            window.open(gameInfo.playstore);
    }

    // download from appstore
    const downloadAppstore = () => {
        if (gameInfo !== undefined)
            window.open(gameInfo.ios);
    }

    // download from direct APK
    const downloadDirectApk = () => {
        if (gameInfo !== undefined)
            window.open(gameInfo.direct_apk);
    }
    
    return (
        <IonPage>
            <IonContent>
                <div id="border-bk" />
                <IonToolbar color="none">
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/token/games" ></IonBackButton>
                    </IonButtons>
                </IonToolbar>
                {
                    gameInfo === undefined  ?
                <div className="spinnerCenter">
                    <IonSpinner name="crescent" />
                </div>
                    :
                <IonGrid className="ion-no-padding">
                    <IonRow>
                        <IonCol className="ion-padding-start">
                            <IonItem className="ion-margin-top ion-margin-bottom" color="transparent" lines="none">
                                <IonImg className="game-avt" src={gameInfo.icon} onError={ ({currentTarget}) => { currentTarget.src = "/assets/img/shop_avt.jpg" } } />
                                <IonLabel className="ion-text-wrap ion-margin-start">
                                    <IonText color="primary"><h1><b>{ gameInfo.caption }</b></h1></IonText>
                                    <IonNote><b>{ gameInfo.tag }</b></IonNote><br/>
                                    <IonNote><i>Version: { gameInfo.version }</i></IonNote>
                                </IonLabel>
                            </IonItem>
                        </IonCol>
                    </IonRow>
                    <IonRow className="ion-padding-start ion-padding-end">
                        <IonCol>
                            { gameInfo.descrip }
                        </IonCol>
                    </IonRow>
                    {
                        gameInfo.playstore != "" ?
                    <IonRow className="ion-padding-start ion-padding-end ion-margin-top">
                        <IonCol>
                        </IonCol>
                        <IonCol size="12" size-md="8" size-lg="6" size-xl="4">
                            <IonButton className="main-but" expand="block" onClick={downloadPlaystore}>
                                <IonIcon icon={logoGooglePlaystore} />&nbsp;&nbsp;
                                <IonLabel>{ GetStr(LANGUAGE.TXT_GAMES_PLAYSTORE) }</IonLabel>
                            </IonButton>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                        :
                    <div/>
                    }
                    {
                        gameInfo.ios != "" ?
                    <IonRow className="ion-padding-start ion-padding-end ion-margin-top">
                        <IonCol>
                        </IonCol>
                        <IonCol size="12" size-md="8" size-lg="6" size-xl="4">
                            <IonButton className="main-but" expand="block" onClick={downloadAppstore}>
                                <IonIcon icon={logoAppleAppstore} />&nbsp;&nbsp;
                                <IonLabel>{ GetStr(LANGUAGE.TXT_GAMES_IOS) }</IonLabel>
                            </IonButton>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                        :
                    <div/>
                    }
                    {
                        gameInfo.direct_apk != "" ?
                    <IonRow className="ion-padding-start ion-padding-end ion-margin-top ion-text-center">
                        <IonCol>
                        </IonCol>
                        <IonCol size="12" size-md="8" size-lg="6" size-xl="4">
                            <IonButton className="main-but" expand="block" color="secondary" onClick={downloadDirectApk}>
                                <IonIcon icon={cloudDownloadOutline} />&nbsp;&nbsp;
                                <IonLabel>{ GetStr(LANGUAGE.TXT_GAMES_DIRECT_DL) }</IonLabel>
                            </IonButton>
                            <IonText color="medium"><small>{ GetStr(LANGUAGE.TXT_GAMES_LOWER_PHONES) }</small></IonText>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                        :
                    <div/>
                    }
                </IonGrid>
                }
            </IonContent>
        </IonPage>
    );

};

export default GameInfoPage;